class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

      // Terms and conditions toggle
      this.termsConditions = this.querySelector('#miniCartTerms');
      this.cartSubmit = this.querySelector('#CartDrawer-Checkout');
      if (this.termsConditions && this.cartSubmit) {
        this.cartSubmit.disabled = !this.termsConditions.checked;
        this.termsConditions.addEventListener('change', () => {
          this.cartSubmit.disabled = !this.termsConditions.checked;
        });
      }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


class CartUpsell extends HTMLElement {
  constructor() {
    super();

    let collectionList = this.querySelector('[data-collection]');
    let cartItemCollection = encodeURIComponent(collectionList.dataset.collection);
    let cartItemPrice = encodeURIComponent(collectionList.dataset.price);
    console.log(cartItemPrice);
    let cartItemThreshold = encodeURIComponent(collectionList.dataset.threshold);
    let amountToFree = encodeURIComponent(collectionList.dataset.amountToFree);
    let prodId = collectionList.dataset.prod;

    this.getUpsells(cartItemCollection, cartItemPrice, cartItemThreshold, collectionList, amountToFree, prodId);
  }

  getUpsells(cartItemCollection, cartItemPrice, cartItemThreshold, collectionList, amountToFree, prodId) {
    if (amountToFree == 0) {
      this.queryComplementaryProds(prodId);
      this.querySelector('.upsell-title').innerText = 'You Might Also Like...';
    } else {
      const minPrice = `&filter.v.price.gte=${cartItemPrice}`;
      const maxPrice = `&filter.v.price.lte=${cartItemThreshold}`;
      const sortBy = `&sort_by=price-ascending`;
      const url = `/collections/${cartItemCollection}?type=product${minPrice}${maxPrice}${sortBy}`;
      this.queryCollectionCards(url, collectionList);
    }
  }

  queryComplementaryProds(prodId) {
    let url = `/recommendations/products?product_id=${prodId}&limit=3&section_id=product-recommendations&intent=complementary`;
    fetch(url)
    .then(response => response.text())
    .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#product-recommendations');

        if (recommendations) {
          let cards = recommendations.querySelectorAll('li');
          if(cards.length > 0) {
          for (let card of cards) {
            card.classList.add('w-full', 'px-4', 'grid__item', 'slider__slide', 'slideshow__slide');
            card.setAttribute('id', `Slide-cart-upsell-${card.dataset.index}`);
          }
        } else {
          this.queryRealtedProds(prodId);
        }
          this.querySelector('ul').innerHTML = recommendations.innerHTML;
        }
        this.dispatchEvent(new CustomEvent('cart-upsell-initialized', { bubbles: true }));
    });
  }

  queryRealtedProds(prodId) {
    let url = `/recommendations/products?product_id=${prodId}&limit=3&section_id=product-recommendations&intent=related`;
    fetch(url)
    .then(response => response.text())
    .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#product-recommendations'); 
        if (recommendations) {
          let cards = recommendations.querySelectorAll('li');
          for (let card of cards) {
            card.classList.add('w-full', 'px-4', 'grid__item', 'slider__slide', 'slideshow__slide');
            card.setAttribute('id', `Slide-cart-upsell-${card.dataset.index}`);
          }
          this.querySelector('ul').innerHTML = recommendations.innerHTML;
        }
        this.dispatchEvent(new CustomEvent('cart-upsell-initialized', { bubbles: true }));
    });
  }

  queryCollectionCards(url, collectionList) {
    fetch(url)
    .then((response) => response.text())
    .then((data) => {
      const html = new DOMParser().parseFromString(data, 'text/html');
      const products = html.querySelectorAll('li.grid__item');
      const cartItemTitles = Array.from(document.querySelectorAll('.cart-item__name')).map(el => el.textContent.trim().toLowerCase());
      const filteredProducts = Array.from(products).filter(
        (product) => {
          const titleEl = product.querySelector('.card__heading, .product-card__title, .card__title');
          const productTitle = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
          return (
        !product.textContent.toLowerCase().includes('gift card') &&
        !cartItemTitles.includes(productTitle)
          );
        }
      );
      Array.from(filteredProducts)
        .slice(0, 3)
        .forEach((product, index) => {
          const parentCls = ['w-full', 'px-4', 'grid__item', 'slider__slide', 'slideshow__slide'];
          parentCls.forEach((cls) => {
            product.classList.add(cls);
          });
          const layout = ['flex-row'];
          layout.forEach((cls) => {
            product.querySelector('div.card').classList.add(cls);
          });
          product.setAttribute('id', `Slide-cart-upsell-${index + 1}`);

          collectionList.appendChild(product);
        });
      this.dispatchEvent(new CustomEvent('cart-upsell-initialized', { bubbles: true }));
    });
  }
}

customElements.define('cart-upsell', CartUpsell);